import { VersionApi } from "@app/services/apiServices/VersionApi";
import { VersionCheckService } from "@app/services/VersionCheck.service";
import { ACCT_CONSTANTS, IAPP_CONFIG } from "@app/constants";
import { IMobileLoginService, MobileLoginService } from "@app/services/MobileLogin.service";
import { OauthService } from "@app/services/oauth.service";
import { GuestPaymentStore } from "@app/services/stores/GuestPaymentStore";
import { UserStore } from "@app/services/stores/UserStore";
import { ContentApi } from '@app/services/apiServices/ContentApi';
import { take } from "rxjs/operators";
import { Component, Inject, NgZone } from "@angular/core";
import { AppDataService } from "@app/services/appData.service";
import { MatDialog } from "@angular/material/dialog";
import { WindowToken } from "@app/util/window.token";
import { Router } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { Tools } from "@app/util/tools";

enum UpdateType {
    NONE = "none",
    RECOMMENDED = "recommended",
    REQUIRED = "required"
}

@Component({
    selector: 'app-login',
    template: require('./login.html')
})
export class LoginComponent {

    appVersion: any;
    appLink: any;
    loggingIn: boolean;
    welcomeMsg;
    appConfig: IAPP_CONFIG;

    constructor(
        @Inject(OauthService) private OauthService: OauthService,
        @Inject(AppDataService) private appService: AppDataService,
        @Inject(GuestPaymentStore) private GuestPaymentStore: GuestPaymentStore,
        @Inject(UserStore) private userStore: UserStore,
        @Inject(MobileLoginService) private MobileLoginService: IMobileLoginService,

        @Inject(VersionCheckService) private VersionCheckService: VersionCheckService,
        @Inject(VersionApi) private VersionApi: VersionApi,
        @Inject(MatDialog) private matDialog: MatDialog,

        @Inject(WindowToken) private window,
        @Inject(ContentApi) private ContentApi: ContentApi,
        @Inject(Router) private router: Router,
        @Inject(NgZone) private ngZone: NgZone,
        @Inject(DomSanitizer) private sanitizer: DomSanitizer,
        @Inject(Tools) private tools: Tools,
    ) {
        this.appConfig = this.appService.appConfig;

        this.appVersion = this.VersionCheckService.localVersion();

        this.loggingIn = false;
        OauthService.setFreshLogin(true);
        this.GuestPaymentStore.clearAllGuest();
        this.fetchWelcomeMessage();
    }

    /**
     * Handles the login process for mobile and web.
     */
    login() {
        this.window.open("registered/#/properties", "_self");
    }

    clickGuestPayment() {
        this.window.open("guest/#/guestpayment", "_self");
    }

    clickGuestAmenitiesPayment() {
        this.window.open("guest/#/amenities/guestpayment", "_self");
    }

    clickRegister() {
        this.window.open("guest/#/register", "_self");
    }

    fetchWelcomeMessage() {
        this.ContentApi.fetchGlobalContentByLocationType('ppwel')
            .pipe(take(1)).subscribe(resp => {
                this.welcomeMsg = resp && resp ? decodeURIComponent(resp.msg) : ''
            });
    }
}

